export const Settings = {
    iPhoneWidth : 375,
    minSideBarWidth : 111,
    siteTitle : "the FINAL TWIST v0.1",
    TRACKING_ID : "G-8R1ZHD36X6"
}

export default Settings;
